// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__2-YMO","label":"SetPasswdForm_label__2mpdS"};